'use client';

import React, { useEffect, useState } from 'react';
import { cookingLoadingService } from "_services/loadingCooking.service";

import styles from '@/styles/menu.module.scss'

import LoadingAnime from '@/assets/lotties/cooking_loader.json'
import Lottie from 'lottie-react';

export default function CookingLoader(){
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        const subscription = cookingLoadingService.onLoading().subscribe((loading) => {
            // console.log('Loading state received:', loading);
            setLoading(loading.isShow);
        });

        return () => {
            subscription.unsubscribe();
        };
    }, []);

    return (
        <>
            {loading && 
            <div className={styles.CookingLoader}>
                  <Lottie animationData={LoadingAnime} loop={true} className={styles.lottie} />
            </div>
            }
        </>
    );
}